var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgUserSlash(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M2.281.49l7.22 5.625a5.992 5.992 0 016-5.906c3.28 0 6 2.719 6 6 0 2.812-1.923 5.11-4.454 5.813L30.03 22.24c.516.375.61 1.078.188 1.547-.375.516-1.078.61-1.547.188L.922 2.225C.406 1.85.312 1.146.734.678 1.11.162 1.813.068 2.281.49zm11.813 9.235c.422.14.89.234 1.406.234 2.063 0 3.75-1.64 3.75-3.75a3.761 3.761 0 00-3.75-3.75 3.731 3.731 0 00-3.75 3.75c0 .844.234 1.594.656 2.203l1.688 1.313zm-1.219 4.78l2.813 2.204h-2.344c-3.094 0-5.625 2.297-6.047 5.25H22.39l2.718 2.156c-.187.094-.328.094-.515.094H6.359c-.75 0-1.359-.61-1.359-1.36 0-4.453 3.469-8.109 7.875-8.343z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgUserSlash);
export default ForwardRef;
